module.exports = __webpack_public_path__ + "static/media/GameDev_Track_Icon.fda36830.svg";